import React from 'react';
import {Stack} from '@mui/material';
import {
  Body,
  designSystemToken,
  Headline,
  Icon,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

function RephraseContent({children}: {children?: React.ReactNode}) {
  return (
    <Stack
      direction="column"
      bgcolor={designSystemToken('semantic.bg.primary')}
      paddingX="36px"
      paddingY="32px"
      marginBottom="74px"
      spacing="8px"
      width="60%"
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Headline size="xl">{translate('Rephrase Dialog')}</Headline>
        <Icon name="Features-Rename" size="large" appearance="primary" />
      </Stack>
      <Body size="lg" style={{marginBottom: '36px'}}>
        {translate('Tailor your script - Select a paragraph to edit')}
      </Body>
      {children}
    </Stack>
  );
}

export default RephraseContent;
